import { takeLatest, put, call, select } from 'redux-saga/effects'
import injectSaga from '../../state/hoc/injectSaga'
import { shouldFetchActivitiesAgain } from './selectors'
import { getAllActivities } from './routines'
import activities from './api'

export function * getAllActivitiesSaga() {
  const shouldFetchAgain = yield select(shouldFetchActivitiesAgain)

  if (!shouldFetchAgain) {
    // FIXME: should return success action for redux-saga-routine promise
    return yield put(getAllActivities.success())
  }

  try {
    yield put(getAllActivities.request())
    const response = yield call(activities.getAll)
    yield put(getAllActivities.success(response))
  } catch (error) {
    yield put(getAllActivities.failure(error))
  } finally {
    yield put(getAllActivities.fulfill())
  }
}

export function * watchGetAllActivitiesSaga() {
  yield takeLatest(getAllActivities.TRIGGER, getAllActivitiesSaga)
}

export const injector = injectSaga({ key: 'activitiesAll', saga: watchGetAllActivitiesSaga })
